import { cn } from '@/shared/lib/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Accessible label. Omit inside a control that already announces its state. */
  label?: string;
}

const SIZES = {
  sm: 'size-4 border-2',
  md: 'size-5 border-2',
  lg: 'size-8 border-[3px]'
} as const;

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent',
        SIZES[size],
        className
      )}
      role={label ? 'status' : 'presentation'}
      {...(label ? { 'aria-label': label } : { 'aria-hidden': true })}
    />
  );
}
